import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'twyne-new.ui';
import moment from 'moment';
import 'moment-timezone';
import { sortBy } from 'lodash';

class SelectTimeZoneInput extends React.Component {
  timeZones () {
    const timeZones = moment.tz.names();
    const offsetTmz = [];

    for (const i in timeZones) {
      const tz = moment.tz(timeZones[i]).format('Z').replace(':00', '').replace(':30', '.5');
      let x = (tz === 0) ? 0 : parseInt(tz, 10).toFixed(2);

      const timeZone = {
        label: `(GMT${moment.tz(timeZones[i]).format('Z')}) ${timeZones[i]}`,
        value: `${timeZones[i]}`,
        time: `${x}`
      };
      offsetTmz.push(timeZone);
    }

    return sortBy(offsetTmz, [function (el) { return -(el.time) }]);
  }

  render () {
    const selectOptions = this.timeZones();

    return (
      <Select
        placeholder={this.props.placeholder}
        value={this.props.value}
        onChange={this.props.onChange}
        options={selectOptions}
      />
    );
  }
}

SelectTimeZoneInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string
};

export default SelectTimeZoneInput;
